import React, { useState, useEffect, useRef } from "react";
import ReactTable from "react-table";
import { confirmAlert } from "react-confirm-alert";
import { ToastContainer, toast } from "react-toastify";
import "./styles.css";

import Header from "../../../Components/Header";
import LeftMenu from "../../../Components/LeftMenu";
import AddEditBranch from "./AddEditBranch.js";
import BranchFilter from "./BranchFilter.js";
import { findallbranches, searchBranchesWithFilter } from "../../../Utils/Services/BranchMaster";
toast.configure();

const BranchMaster = (props) => {
  let [BranchData, setBranchData] = useState([]);
  let [isFiltered, setIsFiltered] = useState(false);
  let [filterParams, setFilterParams] = useState(null);
  let [loading, setLoading] = useState(false);
  const isFilteringRef = useRef(false);
  const toastShownRef = useRef(false);
  const branchFilterRef = useRef(null);

  let [productDropdownOptions, setproductDropdownOptions] = useState([]);
  let [showAddProductNormModal, setshowAddProductNormModal] = useState(false);
  let [showEditNormModal, setshowEditNormModal] = useState(false);
  let [editData, setEditData] = useState({});
  let [showBulUploadModal, setshowBulUploadModal] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isITADMIN = userInfo?.role === "ITADMIN" || props?.role === "ITADMIN";
  useEffect(() => {
    BranchMaster();
    window.scrollTo(0, 0);
  }, []);

  const BranchMaster = () => {
    findallbranches().then((response) => {
      if (response.error) {
        return;
      }
      if (response.data && response.data.error) {
        // Don't show error toast during initial load to avoid conflicts
        console.log("Initial load error:", response.data.message);
      } else {
        setBranchData(response && response.data);
      }
    });
  };

  // Function to refresh table with initial data
  const refreshTableWithInitialData = () => {
    console.log("Refreshing table with initial data...");
    setIsFiltered(false);
    setFilterParams(null);
    BranchMaster();
  };

  const columns = [
    {
      Header: "Branch Id",
      Cell: ({ original }) => {
        return original && original.id ? original.id : null;
      },
    },

    {
      Header: "Branch",
      Cell: ({ original }) => {
        return original && original.branchName ? original.branchName : null;
      },
    },

    {
      Header: "Pincode",
      Cell: ({ original }) => {
        return original && original.pincode ? original.pincode : null;
      },
    },
    {
      Header: "Tehsil",
      Cell: ({ original }) => {
        return original && original.tehsil ? original.tehsil : null;
      },
    },
    {
      Header: "District",
      Cell: ({ original }) => {
        return original && original.district ? original.district : null;
      },
    },
    {
      Header: "State",
      Cell: ({ original }) => {
        return original && original.state ? original.state : null;
      },
    },
    {
      Header: "Status",
      Cell: ({ original }) => {
        return original && original.status === true ? "ACTIVE" : "INACTIVE";
      },
    },
    {
      Header: "Operational Status",
      Cell: ({ original }) => {
        const isOperational = original && original.isOperational === true;
        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <span
              style={{
                padding: "6px 12px",
                borderRadius: "20px",
                fontSize: "13px",
                fontWeight: "500",
                display: "inline-block",
                backgroundColor: isOperational ? "rgba(40, 167, 69, 0.15)" : "rgba(220, 53, 69, 0.15)",
                color: isOperational ? "#28a745" : "#dc3545",
                border: `1px solid ${isOperational ? "#28a745" : "#dc3545"}`,
                minWidth: "120px",
                textAlign: "center",
              }}
            >
              {isOperational ? (
                <>
                  <i className="fas fa-check-circle" style={{ marginRight: "5px" }}></i>
                  Operational
                </>
              ) : (
                <>
                  <i className="fas fa-times-circle" style={{ marginRight: "5px" }}></i>
                  Not Operational
                </>
              )}
            </span>
          </div>
        );
      },
    },
    {
      Header: "Action",
      Cell: ({ original }) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {isITADMIN ? (
              <i
                onClick={() => handleEditBranchMaster(original)}
                className="fas fa-user-edit text-primary"
                style={{ cursor: "pointer" }}
              />
            ) : (
              <i
                onClick={() => handleEditBranchMaster(original)}
                className="fas fa-eye text-secondary"
                style={{ cursor: "pointer" }}
                title="View Only"
              />
            )}
          </div>
        );
      },
    },
  ];

  const handleAddBranch = (id) => {
    setshowAddProductNormModal(!showAddProductNormModal);
  };

  const handleEditBranchMaster = (obj) => {
    setshowEditNormModal(!showEditNormModal);
    setEditData(obj);
  };

  const handleBulkUpload = () => {
    setshowBulUploadModal(!showBulUploadModal);
  };

  const handleFilter = async (filterData) => {
    console.log("BranchMaster handleFilter called with:", filterData);
    console.log("BranchMaster handleFilter stack trace:", new Error().stack);
    if (loading || isFilteringRef.current) {
      console.log("Filter: Already loading or filtering, skipping");
      return;
    }
    isFilteringRef.current = true;
    setLoading(true);
    setFilterParams(filterData);
    setIsFiltered(true);
    
    try {
      const response = await searchBranchesWithFilter(filterData);
      
      console.log("Filter API Response:", response); // Debug log
      const actualResponse = response.data;
      
      if (response.error) {
        console.log("Filter: HTTP error -", response.message);
        // Error toast already shown by HTTP interceptor
        // Clear filter fields and reload initial data when error occurs
        if (branchFilterRef.current) {
          branchFilterRef.current.clear();
        }
        return;
      } else if (actualResponse && actualResponse.status === "success" && actualResponse.result) {
        // Store the search results
        console.log("Setting filtered data:", actualResponse.result); // Debug log
        setBranchData(actualResponse.result);
        toast.success(`Found ${actualResponse.resultCount} branches`, {
          type: toast.TYPE.SUCCESS,
          autoClose: 3000,
        });
      } else if (actualResponse && actualResponse.data) {
        // Fallback for different response structure
        console.log("Setting filtered data (fallback):", actualResponse.data); // Debug log
        setBranchData(actualResponse.data);
        toast.success(`Found ${actualResponse.data.length} branches`, {
          type: toast.TYPE.SUCCESS,
          autoClose: 3000,
        });
      } else {
        console.error("Unexpected response structure:", actualResponse);
        // Error toast already shown by HTTP interceptor
        // Clear filter fields and reload initial data when error occurs
        if (branchFilterRef.current) {
          branchFilterRef.current.clear();
        }
      }
    } catch (error) {
      console.error("Filter error:", error);
      // Error toast already shown by HTTP interceptor
      // Clear filter fields and reload initial data when error occurs
      if (branchFilterRef.current) {
        branchFilterRef.current.clear();
      }
    } finally {
      setLoading(false);
      isFilteringRef.current = false;
    }
  };

  const handleClearFilter = async () => {
    setLoading(true);
    
    // Reset all filter states
    setIsFiltered(false);
    setFilterParams(null);
    
    try {
      // Call the API to reload all data
      const response = await findallbranches();
      console.log("Clear - Reload API Response:", response); // Debug log
      
      if (response.error) {
        // Don't show error toast during clear to avoid conflicts
        console.log("Clear reload error:", "Error reloading data");
      } else if (response.data && response.data.error) {
        // Don't show error toast during clear to avoid conflicts
        console.log("Clear reload error:", response.data.message);
      } else {
        // Set the data directly for immediate UI update
        setBranchData(response.data);
      }
    } catch (error) {
      console.error("Clear - Reload error:", error);
      // Don't show error toast during clear to avoid conflicts
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="dash_grid">
      <ToastContainer />
      <LeftMenu />
      <main className="bg-white">
        <Header {...props} />
        <section className="container-fluid mb-5">
          <h5 className="text-center mt-5 mx-auto user-box">Branch Master</h5>
          
          {/* Branch Filter */}
          <BranchFilter
            ref={branchFilterRef}
            onFilter={handleFilter}
            onClear={handleClearFilter}
            loading={loading}
          />
          
          <div className="d-flex align-items-center mt-3" style={{ marginBottom: "0" }}>
            {isITADMIN && (
              <button
                disabled={false}
                onClick={handleAddBranch}
                className="add-btn ml-auto btn btn-info btn-lg"
                style={{ marginRight: "20px", marginBottom: "15px" }}
              >
                {" "}
                Add{" "}
              </button>
            )}
            {showAddProductNormModal && (
              <AddEditBranch
                action={"add"}
                BranchMaster={BranchMaster}
                handleAddBranch={handleAddBranch}
                productDropdownOptions={productDropdownOptions}
              />
            )}
            {showEditNormModal && (
              <AddEditBranch
                action={"edit"}
                BranchMaster={BranchMaster}
                editData={editData}
                handleEditBranchMaster={handleEditBranchMaster}
                productDropdownOptions={productDropdownOptions}
              />
            )}
          </div>

          <div className={`react-table`} style={{ marginTop: "0", marginBottom: "0", position: 'relative' }}>
            {loading && (
              <div className="text-center py-4" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000, backgroundColor: 'rgba(255, 255, 255, 0.9)', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            <ReactTable
              data={BranchData}
              columns={columns}
              defaultPageSize={10}
            />
          </div>
        </section>
      </main>
    </div>
  );
};

export default BranchMaster;
